import { PostCommentWithRepliesDto } from "@/api/comments/feed/types";
import { FeedPostComment } from "../../Comment/FeedPost";

export interface Props {
  feedPostId: string;
  comment: PostCommentWithRepliesDto;
  depth: number;
  replyTo?: string;
}

export default function FeedPostCommentsTree({
  feedPostId,
  comment,
  depth,
}: Props) {
  return !comment.deleted ? (
    <div key={comment.createdAt.toString()}>
      <FeedPostComment feedPostId={feedPostId} comment={comment} />
      {comment.replies && (
        <div className="pl-16">
          {comment.replies.map((reply) => (
            <FeedPostCommentsTree
              key={reply.id}
              feedPostId={feedPostId}
              comment={reply}
              depth={depth + 1}
            />
          ))}
        </div>
      )}
    </div>
  ) : null;
}
